import React from 'react';
import { render } from 'react-dom';

import BancontactAdyenCaptureCreditCards from '@features/BancontactAdyenCreditCard/BancontactAdyenCaptureCreditCard/BancontactAdyenCaptureCreditCard';
import BancontactAdyenManageCreditCards from '@features/BancontactAdyenCreditCard/BancontactAdyenManageCreditCards/BancontactAdyenManageCreditCards';
import { getSentryService } from '@services/sentryService';
import { MaybeNullable } from '@types-internal/index';
import { getDefaultConfig } from '@utils/configUtils';
import {
  normalizeAdyenCaptureCreditCardsProps,
  normalizeBancontactAdyenManageCreditCardsProps,
} from '@utils/extractFromHtml';

const runningEnv = window.environment;
const defaultConfig = getDefaultConfig();
const isLocalEnv = runningEnv === 'local';
function log(...values: unknown[]) {
  if (isLocalEnv) {
    console.log.apply(console.log, values);
  }
}

export const renderBancontactAdyenManageCreditCards = () => {
  const container = document.getElementById('bancontact-payment-method-selection');

  if (container && container.dataset.paymentMethod === 'BC') {
    const sentryService = getSentryService(runningEnv, defaultConfig);

    try {
      const props = normalizeBancontactAdyenManageCreditCardsProps(container, runningEnv);

      log('Render Bancontact Adyen bancontact-payment-method-selection with', props);

      render(
        <React.StrictMode>
          <BancontactAdyenManageCreditCards {...props} />
        </React.StrictMode>,
        container,
      );
    } catch (error) {
      sentryService.captureException({ error });
    }
  } else {
    log('Bancontact Adyen bancontact-payment-method-selection container not found');
  }
};

export const renderBancontactAdyenCaptureCreditCard = (
  maybeCustomerType: MaybeNullable<string>,
) => {
  const container = document.getElementById('bancontact-adyen-capture-credit-cards');

  if (container) {
    const sentryService = getSentryService(runningEnv, defaultConfig);
    try {
      const props = normalizeAdyenCaptureCreditCardsProps(
        container,
        runningEnv,
        maybeCustomerType,
        ['bcmc'],
      );

      log('Render bancontact-adyen-capture-credit-cards with', props);

      render(
        <React.StrictMode>
          <BancontactAdyenCaptureCreditCards {...props} />
        </React.StrictMode>,
        container,
      );
    } catch (error) {
      sentryService.captureException({ error });
    }
  } else {
    log('bancontact-adyen-capture-credit-cards container not found');
  }
};
